// extracted by mini-css-extract-plugin
module.exports = {"clear-icon":"styles-module__clear-icon___1iJ0u"};